// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"f671e09f","453":"e76c913f"}[chunkId] + ".chunk.js";
};